import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { useRef } from "react";
import { forwardRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const Transition = forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EmiTenureDialog = (props) => {
  const handleClose = () => {
    props.closeEmiAlertDialog();
  };

  const handleOk = () => {
    props.handleEmiAlertDialogOk();
  };
  const dispatch = useDispatch();
  //shortcut key
  const okRef = useRef(null);
  const cancelRef = useRef(null);
  const closeRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "reSchedulement",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let refList = {
      okRef: okRef,
      cancelRef: cancelRef.current !== null ? cancelRef : null,
      closeRef: closeRef.current !== null ? closeRef : null,
    };
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "q") {
        cancelRef && cancelRef.current !== null && cancelRef.current.click();
        closeRef && closeRef.current !== null && closeRef.current.click();
      } else if (charCode === "k") {
        okRef.current.click();
      }
    }
  };

  return (
    <>
      <Dialog
        open={props.openEmiAlertDialog}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        {props.currentValueHasError ? (
          <DialogTitle>{<font color="Red">Error</font>}</DialogTitle>
        ) : (
          <DialogTitle>{"Information"}</DialogTitle>
        )}
        <DialogContent>
          {props.dialogFor === "emi" ? (
            props.currentValueHasError ? (
              <DialogContentText id="alert-dialog-slide-description">
                Current EMI and Revised EMI Should not be same.
                <br />
                Please Enter Different Amount (₹).
              </DialogContentText>
            ) : (
              <DialogContentText id="alert-dialog-slide-description">
                {Number(props.revisedEMI) >
                Number(props.suggestEmiValue.replace(/,/g, ""))
                  ? "Maximum "
                  : "Minimum "}
                EMI should be{" "}
                <font color="blue" size="+0.5">
                  {props.suggestEmiValue} (₹)
                </font>
                <br />
                and Tenure should be{" "}
                <font color="blue" size="+0.5">
                  {props.suggestTenureValue} (In Months){" "}
                </font>
                <br />
                Is it ok to continue with this value?
              </DialogContentText>
            )
          ) : props.currentValueHasError ? (
            <DialogContentText id="alert-dialog-slide-description">
              Current Tenure and Revised Tenure Should not be same.
              <br />
              Please Enter Different Tenure (In Months).
            </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-slide-description">
              Maximum Tenure should be{" "}
              <font color="blue" size="+0.5">
                {props.suggestTenureValue} (In Months){" "}
              </font>
              <br />
              And EMI should be{" "}
              <font color="blue" size="+0.5">
                {props.suggestEmiValue} (₹){" "}
              </font>
              <br />
              Is it ok to continue with this value?
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          {props.currentValueHasError ? (
            <Tooltip title="Ctrl+Q" placement="top">
              <Button onClick={handleClose} ref={closeRef}>
                Close
              </Button>
            </Tooltip>
          ) : (
            <Tooltip title="Ctrl+Q" placement="top">
              <Button onClick={handleClose} ref={cancelRef}>
                Cancel
              </Button>
            </Tooltip>
          )}
          {props.currentValueHasError ? (
            <></>
          ) : (
            <Tooltip title="Ctrl+K" placement="top">
              <Button onClick={handleOk} ref={okRef}>
                OK
              </Button>
            </Tooltip>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};
export default EmiTenureDialog;
